var map = {
	"./basics1.png": 4904,
	"./basics2.png": 6883,
	"./basics3.png": 7050,
	"./basics4.png": 9109,
	"./basics5.png": 7484,
	"./basics6.png": 4519,
	"./basicsBanner.png": 7819,
	"./basicsBannerImg.png": 4886,
	"./basicsBannerTxt.png": 331,
	"./basicsImg1.png": 83,
	"./basicsImg2.png": 8104,
	"./basicsImg3.png": 6497,
	"./basicsImg4.png": 1934,
	"./basicsImg5.png": 7719,
	"./basicsImg6.png": 684,
	"./fruity1.png": 1842,
	"./fruity2.png": 6985,
	"./fruity3.png": 5808,
	"./fruityBanner.png": 3937,
	"./fruityBannerImg.png": 9660,
	"./fruityBannerTxt.png": 7085,
	"./fruityImage1.png": 8127,
	"./fruityImage2.png": 5668,
	"./fruityImage3.png": 6797,
	"./fruityImg1.png": 549,
	"./fruityImg2.png": 3198,
	"./fruityImg3.png": 1511,
	"./specialty1.png": 6365,
	"./specialty2.png": 5686,
	"./specialty3.png": 3775,
	"./specialty4.png": 5120,
	"./specialty5.png": 9945,
	"./specialty6.png": 4802,
	"./specialty7.png": 155,
	"./specialty8.png": 3916,
	"./specialty9.png": 6805,
	"./specialtyBanner.png": 4224,
	"./specialtyBannerImg.png": 8467,
	"./specialtyBannerTxt.png": 1906,
	"./specialtyImage1.png": 1470,
	"./specialtyImage10.png": 8172,
	"./specialtyImage2.png": 1829,
	"./specialtyImage3.png": 8940,
	"./specialtyImage4.png": 3811,
	"./specialtyImage5.png": 4954,
	"./specialtyImage6.png": 9185,
	"./specialtyImage7.png": 8056,
	"./specialtyImage8.png": 3007,
	"./specialtyImage9.png": 342,
	"./specialtyImg1.png": 8556,
	"./specialtyImg2.png": 7031,
	"./specialtyImg3.png": 9342,
	"./specialtyImg4.png": 1809,
	"./specialtyImg5.png": 5512,
	"./specialtyImg6.png": 8723,
	"./specialtyImg7.png": 7146,
	"./specialtyImg8.png": 1005,
	"./specialtyImg9.png": 8500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9451;